import { db } from 'firestoreConfig'
import { v4 as uuid } from 'uuid'

const COLLECTION = 'student_payment_problems'

export const fetchPaymentProblems = () => {
  return db
    .collection(COLLECTION)
    .get()
    .then(snapshot => {
      const items = []
      snapshot.forEach(doc => {
        items.push({ id: doc.id, ...doc.data() })
      })
      return items.sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''))
    })
    .catch(error => {
      console.error('Error fetching payment problems:', error)
      return []
    })
}

export const addPaymentProblem = ({ date, amount, title, extractedName }) => {
  const id = uuid()
  const doc = {
    id,
    date,
    amount,
    title,
    extractedName: extractedName || null,
    createdAt: new Date().toISOString()
  }
  return db
    .collection(COLLECTION)
    .doc(id)
    .set(doc)
    .then(() => doc)
    .catch(error => {
      console.error('Error adding payment problem:', error)
      throw error
    })
}

export const addPaymentProblems = items => {
  const batch = db.batch()
  items.forEach(({ date, amount, title, extractedName }) => {
    const id = uuid()
    const ref = db.collection(COLLECTION).doc(id)
    batch.set(ref, {
      id,
      date,
      amount,
      title,
      extractedName: extractedName || null,
      createdAt: new Date().toISOString()
    })
  })
  return batch.commit()
}

export const removePaymentProblem = id => {
  return db
    .collection(COLLECTION)
    .doc(id)
    .delete()
    .catch(error => {
      console.error('Error removing payment problem:', error)
      throw error
    })
}
